/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Mon Apr 15 2024
 **/

import { Configure } from "@/frameworks/libraries/utilities";

function removeMeFromList(ids: string[]): string[];
function removeMeFromList<T>(ids: ({ id: string } & T)[]): ({ id: string } & T)[];
function removeMeFromList<T>(ids: string[] | ({ id: string } & T)[]) {
	const myID = Configure.userID;
	return ids.filter((v) => {
		if (typeof v === "string") {
			return v !== myID;
		} else {
			return v.id !== myID;
		}
	});
}

export default removeMeFromList;
